<template>
  <div class="login-container">
    <div class="login-box">
      <img class="logo" src="@/assets/logo.png" alt="Logo">
      <h1 class="title">宏锦工程机械有限责任公司</h1>
      <van-form @submit="onSubmit">
        <van-field
            v-model="staff.code"
            label="用户名"
            placeholder="请输入用户名"
        />
        <van-field
            v-model="staff.password"
            label="密码"
            type="password"
            placeholder="请输入密码"
        />
        <div class="button-container">
          <van-button type="info" round block native-type="submit" class="login-button"
                      :loading="loading" loading-text="登录中" style="transition: background 0.3s;">登录</van-button>
        </div>
      </van-form>
      <div class="user-agreement">
        <p>登录即表示您同意我们的 <a href="#">用户协议</a> 和 <a href="#">隐私政策</a></p>
      </div>
    </div>
  </div>
</template>

<script>
import {Toast} from "vant";
import {login} from "@/api/login";

export default {
  data () {
    return {
      staff: {
        code: '',
        password: ''
      },
      loading: false
    }
  },
  methods: {
    onSubmit() {
      this.loading = true
      // 处理登录逻辑
      console.log('登录信息：', this.staff);
      // 在这里可以添加登录的逻辑，例如向后端发送登录请求
      login(this.staff).then(
          response => {
            if (response.code === 200) {
              this.$store.commit('staff/SET_STAFF', response.data) // 存储用户信息
              this.$store.commit('token/SET_TOKEN', response.token) // 存储token
              Toast.success('登陆成功！');
              this.$router.push({
                path: '/'
              })
            } else {
              Toast.fail(response.message);
              this.loading = false
            }
          }
      )
    }
  }
}
</script>

<style>
.login-container {
  background: #f0f6fa;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.login-box {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.2);
  padding: 30px;
  text-align: center;
}

.logo {
  width: 100px;
  height: 100px;
  margin-bottom: 20px;
}

.title {
  font-size: 24px;
  color: #333;
  margin-bottom: 20px;
}

.button-container {
  margin-top: 20px; /* 调整登录按钮的上外边距 */
}

input {
  width: 100%;
  padding: 12px;
  border: none;
  border-radius: 5px;
  background: #f4f4f4;
  font-size: 16px;
}

.login-button:hover {
  background: #2980b9;
}

.user-agreement a {
  color: #3498db;
  text-decoration: none;
}

.user-agreement a:hover {
  text-decoration: underline;
}
</style>
